import React, { FC } from 'react';
import { TableSortLabel, Typography } from '@mui/material';
import { OrderBy } from 'models/search-result';

type SortableHeaderLabelProps = {
    field: string;
    label: string;
    orderBy: OrderBy;
    onSortChange: (field: string) => void;
};

// Clickable column header for the flex-box price list tables (they are virtualized
// lists, not MUI tables, so TableSortLabel is used on its own).
const SortableHeaderLabel: FC<SortableHeaderLabelProps> = ({ field, label, orderBy, onSortChange }) => (
    <TableSortLabel
        active={orderBy.orderBy === field}
        direction={orderBy.orderDirection}
        onClick={() => onSortChange(field)}
    >
        <Typography variant="subtitle2">{label}</Typography>
    </TableSortLabel>
);

export default SortableHeaderLabel;
